"use client";

import clsx from "clsx";
import useEmblaCarousel from "embla-carousel-react";
import Image from "next/image";
import { useCallback } from "react";
import type { z } from "zod";

import type { UploadedFileSchema } from "../../../_hooks/use-upload-file";

export function HeroImageCarousel({
  imageUrls,
}: {
  imageUrls: z.infer<typeof UploadedFileSchema>[];
}) {
  const isCarouselActive = imageUrls.length > 1;
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: true,
    active: isCarouselActive,
  });
  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);
  return (
    <div className="w-full max-w-[1020px] overflow-hidden">
      <div ref={emblaRef} className="relative">
        <div className="flex">
          {imageUrls.map((imageUrl, i) => (
            <div
              key={i}
              className="aspect-33/20 max-h-[612px] w-full min-w-0 flex-[0_0_100%]"
            >
              <Image
                src={imageUrl.rawUrl}
                alt="slide"
                sizes="100vw"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
                width={33}
                height={20}
              />
            </div>
          ))}
        </div>
        <div
          className={clsx(
            "absolute right-[10px] bottom-[10px] flex gap-[5px] md:right-[30px] md:bottom-[30px] md:gap-[10px]",
            {
              hidden: !isCarouselActive,
            },
          )}
        >
          <button
            // カルーセルの送りだけで、行動の分析対象にならない
            data-analytics-ignore
            className="bg-slightbeige flex aspect-2/3 max-h-[30px] max-w-[20px] items-center justify-center p-[5px] md:max-h-[80px] md:max-w-[50px]"
            onClick={scrollPrev}
          >
            <Image
              src="/i/icon_chevron_left_thin.svg"
              alt="前の画像へ"
              style={{
                width: "100%",
                height: "auto",
              }}
              width={30}
              height={60}
            />
          </button>
          <button
            // カルーセルの送りだけで、行動の分析対象にならない
            data-analytics-ignore
            className="bg-slightbeige flex aspect-2/3 max-h-[30px] max-w-[20px] items-center justify-center p-[5px] md:max-h-[80px] md:max-w-[50px]"
            onClick={scrollNext}
          >
            <Image
              src="/i/icon_chevron_left_thin.svg"
              alt="次の画像へ"
              style={{
                width: "100%",
                height: "auto",
              }}
              width={30}
              height={60}
              className="rotate-180"
            />
          </button>
        </div>
      </div>
    </div>
  );
}
